import 'react-quill/dist/quill.snow.css';

import SearchComponent from '@components/Default/Search/SearchComponent';
import SelectableUnitUserComponent from '@components/SelectableUnitUserComponent';
import IPagination from '@interfaces/IPagination';
import { IRole } from '@interfaces/IRole';
import RoleService from '@services/RoleService';
import UserService from '@services/UserService';
import { Col } from 'antd';
import _ from 'lodash';
import React from 'react';

import Page from '../components/Page';
import Table from '../components/TableComponent';
import NotificationComponent from '../helpers/_showNotifications';
import I18n from '../i18n';
import { IUser } from '../interfaces/IUser';
import AppContext from '../services/Context';
import styled from '../styled-components';

type PropType = { history: { replace: Function }; match: any; }

type StateType = {
  isLoading: boolean;
  iconLoading?: boolean;
  tableData: IRole[];
  unitAmount?: number;
  totalShowData?: number;
  curOffset?: string;
  disabled?: boolean;
  search: string;
  filter?: boolean;
  filteredTableData: IRole[];
  serverResponse: any;

  //Users
  showUserSelectModal: boolean;
  selectedRole: string,
  selectedIDRole: string,

  searchAvailableUsers: string;
  searchSavedUsers: string;

  loadingAvailableUsers: boolean;
  loadingSavedUsers: boolean;

  availableUsersData: IUser[];
  savedUsersData: any[];
  availableUsersAmount: number;
  savedUsersAmount: number;
  loadingMoreAvailableUsers: boolean;
  loadingMoreSavedUsers: boolean;
  availableUsersCurOffset?: string;
  savedUsersCurOffset?: string;
  // selectedAuditorObject?: AuditorInterface;
};

const tableColumns = [{
  title: 'table.profile.name',
  dataIndex: 'name',
  key: 'name',
  class: 'name',
}, {
  title: 'table.profile.alias',
  dataIndex: 'alias',
  key: 'alias',
}, {
  title: 'table.units.linkUsers',
  dataIndex: 'linkUsers',
  key: 'linkUsers',
}];

const usersAvailableTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  }
];

const usersSavedTableColumns = [
  {
    title: 'table.units.users.name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'table.units.users.username',
    dataIndex: 'username',
    key: 'username'
  },
  {
    title: '',
    dataIndex: 'loading',
    key: 'loading',
    width: "10%"
  },
];
class Profile extends React.Component<PropType, StateType> {

  private _service: RoleService = new RoleService();
  private _usersService: UserService = new UserService();
  private unitId: string = '';
  private pillar: string = '';

  private SelectableUserUnitRef: any;

  constructor(props: any) {
    super(props);

    this.SelectableUserUnitRef = React.createRef();
    this.loadMoreAvailableUsers = this.loadMoreAvailableUsers.bind(this);
    this.loadMoreSavedUsers = this.loadMoreSavedUsers.bind(this);
  }

  state = {
    isLoading: true,
    iconLoading: false,
    tableData: [],
    filteredTableData: [],
    curOffset: undefined,
    disabled: undefined,
    search: '',
    filter: false,
    serverResponse: undefined,
    showUserSelectModal: false,
    selectedRole: '',
    selectedIDRole: '',

    searchAvailableUsers: '',
    searchSavedUsers: '',

    loadingAvailableUsers: false,
    loadingSavedUsers: false,

    availableUsersData: [],
    savedUsersData: [],
    availableUsersAmount: 0,
    savedUsersAmount: 0,
    loadingMoreAvailableUsers: false,
    loadingMoreSavedUsers: false,
    availableUsersCurOffset: undefined,
    savedUsersCurOffset: undefined,
  };

  setLocale(locale: any) {
  }

  setUnit(unit: string) {
    this.unitId = unit;
  }

  setPillar(pillar: string) {
    this.pillar = pillar;
  }

  componentDidMount() {
    this.getRoles(true);
  }

  getRoles = async (reset: boolean) => {
    if (reset) {
      await this.setState({
        curOffset: undefined,
        isLoading: true,
      });
    }
    try {
      const data: any = await this._service.listAll();
      const dataTableCreate: any = [];
      data.map(async (item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          alias: item.alias,
        })
      })

      let newDataTableCreate: IRole[] = [];
      if (!reset) {
        newDataTableCreate = this.state.tableData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);
      await this.setState({
        isLoading: false,
        iconLoading: false,
        unitAmount: data.count,
        tableData: newDataTableCreate,
        curOffset: data.offset
      });

    } catch (error) {
      console.warn(error);
      await this.setState({
        isLoading: false,
      });
    }
  };


  formatDataToTable(data: IRole[]) {
    const nextDataTable: any = [];
    data.map(async (item: any) => {
      const linkUserInfo = (
        <Col >
          <a href="#" onClick={() => this.toggleUserSelectModal(item.id || '')}>{I18n.l('table.units.linkUsers')}</a>
        </Col>
      );

      nextDataTable.push({
        id: item.id,
        name: item.name,
        alias: item.alias,
        linkUsers: linkUserInfo,
        createdAt: item.createdAt,
      })
    })

    return nextDataTable;
  }

  searchData = async (event: any) => {
    let searchTableData: IRole[] = [];
    const SearchValue = event === '' ? false : event.target.find.value;
    await this.setState({
      search: SearchValue,
      isLoading: true,
    })

    if (!SearchValue) {
      this.getRoles(true);
    }
    try {
      _.some(this.state.tableData, (o: any) => {
        if (_.includes(o.name, SearchValue) || _.includes(o.alias, SearchValue)) {
          searchTableData.push(o)
        }
      })
      await this.setState({
        isLoading: false,
        tableData: searchTableData
      })
    }
    catch (err) {
      console.log(err)
    }
  }

  //#region USER SELECT TO UNIT
  toggleUserSelectModal = async (roleID?: string) => {
    await this.setState({ selectedRole: roleID || '' })

    if (this.state.showUserSelectModal == false) {
      this.getAvailableUsers(true, true);
      this.getSavedUsers(true, true);
    }
    await this.setState({
      showUserSelectModal: !this.state.showUserSelectModal,
      searchAvailableUsers: '',
      searchSavedUsers: '',
    });
  }

  onRemoveUser = async (userId: string) => {
    this.setLoadingSavedUserData(userId, true);
    const userObj: any = await this.getUserSavedObject(userId);

    try {
      if (userObj) {
        await this._usersService.roleRemove(userId, userObj.idRole);
        this.setLoadingSavedUserData(userId, false);
        this.userRemoved(userId, userObj);
        NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userUnlikedRoleSuccess"));
      } else {
        console.error('Usuário não encontrado')
      }
    } catch (e) {
      this.setLoadingSavedUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userRemoved = async (id: string, userRemoved: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newAvailableData: any[] = [...availableUsersData];
    newAvailableData.push(userRemoved);

    const userIndexToRemove = savedUsersData.findIndex((item: any) => item.id === id);
    let nextSavedData = [...savedUsersData];
    nextSavedData.splice(userIndexToRemove, 1);

    await this.setState({
      savedUsersData: nextSavedData,
      availableUsersData: newAvailableData,
      savedUsersAmount: (this.state.savedUsersAmount - 1),
      availableUsersAmount: (this.state.availableUsersAmount + 1)
    });
    if (this.state.savedUsersData.length == 0 && this.state.savedUsersAmount > 0) {
      this.getPagingRemoveUsers();
    }

  }

  onAddUser = async (userId: string) => {
    const { selectedRole } = this.state
    this.setLoadingAvailableUserData(userId, true);
    const userObj: any = this.getUserAvailableObject(userId);

    const data: any = {
      id: selectedRole,
      role: selectedRole,
      unit: this.unitId,
      pillar: this.pillar
    }

    try {
      console.log('entrou aqui')
      const response: any = await this._usersService.roleAdd(userId, data);

      this.setLoadingAvailableUserData(userId, false);
      this.userAdded(userId, userObj);
      NotificationComponent.Notify('success', I18n.l("common.success"), I18n.l("titles.userRoleSuccess"));

      const idRole = response.roles.find((x: any) => x.unit === this.unitId && x.pillar === this.pillar && x.role === this.state.selectedRole);

      if (userObj) {
        userObj.idRole = idRole.id
      }

      this.userAdded(userId, userObj);

    } catch (e) {
      this.setLoadingAvailableUserData(userId, false);
      NotificationComponent.Notify('error', I18n.l("common.error"), e);
    }
  }

  userAdded = async (id: string, userToSave: any) => {
    const { availableUsersData, savedUsersData } = this.state;

    const newSaveData: any[] = [...savedUsersData];
    newSaveData.push(userToSave);

    const userIndexToRemove = availableUsersData.findIndex((item: any) => item.id === id);
    let nextAvailableData = [...availableUsersData];
    nextAvailableData.splice(userIndexToRemove, 1);

    this.SelectableUserUnitRef.current.saveAvailableUserDone();

    await this.setState({
      availableUsersData: nextAvailableData,
      savedUsersData: newSaveData,
      savedUsersAmount: (this.state.savedUsersAmount + 1),
      availableUsersAmount: (this.state.availableUsersAmount - 1)
    });
    if (this.state.availableUsersData.length == 0 && this.state.availableUsersAmount > 0) {
      this.getPagingAddUsers();
    }
    // this.setAuditsToUser();
  }

  getUserAvailableObject(id: string) {
    const { availableUsersData } = this.state;
    let user = undefined;

    user = availableUsersData.find((item: any) => item.id === id);

    return user;
  }

  async getUserSavedObject(id: string) {
    const { savedUsersData } = this.state;
    let user = undefined;

    user = savedUsersData.find((item: any) => item.id === id);

    return user;
  }

  setLoadingAvailableUserData = async (userId: string, loading: boolean) => {
    const { availableUsersData } = this.state;

    const user: any = availableUsersData.find((item: any) => {
      return item.id == userId;
    });
    const indexOf = availableUsersData.indexOf(user);

    const newUsersData: any[] = [...availableUsersData];
    newUsersData[indexOf].loading = loading;
    newUsersData[indexOf].disabled = loading;

    await this.setState({ availableUsersData: newUsersData });
  }

  setLoadingSavedUserData = async (userId: string, loading: boolean) => {
    const { savedUsersData } = this.state;

    const user: any = savedUsersData.find((item: any) => {
      return item.id == userId;
    });

    const indexOf = savedUsersData.indexOf(user);

    const newUsersData: any[] = [...savedUsersData];
    newUsersData[indexOf].loading = loading;

    await this.setState({ savedUsersData: newUsersData });
  }

  onSearchAvailableUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    await this.setState({ searchAvailableUsers: SearchValue });

    this.getAvailableUsers(true, true);
  }

  onSearchSavedUsers = async (event: any) => {
    event.preventDefault();
    const SearchValue = event === '' ? '' : event.target.find.value;
    await this.setState({ searchSavedUsers: SearchValue });

    this.getSavedUsers(true, true);
  }

  getPagingAddUsers = async () => {
    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: '',
        notUnit: this.state.selectedRole,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;

      data.items.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          username: item.username,
          loading: loadingValue,
          disabled: false,
        })
      });

      let newDataTableCreate: any[] = [];
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getPagingRemoveUsers = async () => {
    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        hasRole: this.state.selectedRole,
        pillar: this.pillar,
        unit: this.unitId,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      let dataTableCreate: any[] = [];

      data.items.map(async (item: any) => {
        dataTableCreate.push({
          name: item.name,
          username: item.username,
          id: item.id,
          loading: false,
        })
      });

      let newDataTableCreate: any[] = [];

      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
        savedUsersCurOffset: data.offset,
      });


    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };


  getAvailableUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    await this.setState({
      loadingAvailableUsers: showLoading,
      loadingMoreAvailableUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      await this.setState({
        availableUsersData: [],
        availableUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: this.unitId,
        notRole: this.state.selectedRole,
        pillar: this.pillar,
        to: undefined,
        from: undefined,
        search: this.state.searchAvailableUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.availableUsersCurOffset
      });

      const dataTableCreate: any[] = [];

      const loadingValue: boolean = false;

      data.items.map((item: any) => {
        dataTableCreate.push({
          id: item.id,
          name: item.name,
          username: item.username,
          loading: loadingValue,
        })
      });

      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.availableUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        availableUsersData: newDataTableCreate,
        loadingAvailableUsers: false,
        availableUsersAmount: data.count,
        loadingMoreAvailableUsers: false,
        availableUsersCurOffset: data.offset,
      });
    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingAvailableUsers: false,
        loadingMoreAvailableUsers: false,
      });
    }
  };

  getSavedUsers = async (reset: boolean, showLoading: boolean, loadingMore?: boolean) => {
    await this.setState({
      loadingSavedUsers: showLoading,
      loadingMoreSavedUsers: (!!loadingMore ? loadingMore : false)
    });

    if (reset) {
      await this.setState({
        savedUsersData: [],
        savedUsersCurOffset: undefined,
      });
    }

    try {
      const data: IPagination<IUser> = await this._usersService.paging({
        unit: this.unitId,
        hasRole: this.state.selectedRole,
        pillar: this.pillar,
        to: undefined,
        from: undefined,
        search: this.state.searchSavedUsers,
        disabled: this.state.disabled,
        limit: 6,
        offset: this.state.savedUsersCurOffset
      });

      let dataTableCreate: any[] = [];

      data.items.forEach(async (item: any) => {
        const idRole = item.roles.find((x: any) => x.unit === this.unitId && x.pillar === this.pillar && x.role === this.state.selectedRole);
        dataTableCreate.push({
          name: item.name,
          username: item.username,
          id: item.id,
          loading: false,
          idRole: idRole.id
        })
      });


      let newDataTableCreate: any[] = [];
      if (!reset) {
        newDataTableCreate = this.state.savedUsersData || [];
      }
      newDataTableCreate = newDataTableCreate.concat(dataTableCreate);

      await this.setState({
        savedUsersData: newDataTableCreate,
        loadingSavedUsers: false,
        savedUsersAmount: data.count,
        loadingMoreSavedUsers: false,
        savedUsersCurOffset: data.offset,
      });

    } catch (error) {
      NotificationComponent.Notify('error', I18n.l("common.error"), error);
      await this.setState({
        loadingSavedUsers: false,
        loadingMoreSavedUsers: false,
      });
    }
  };

  loadMoreAvailableUsers = () => {
    this.getAvailableUsers(false, false, true);
  }

  loadMoreSavedUsers = () => {
    this.getSavedUsers(false, false, true);
  }
  //#endregion

  render() {
    const {
      isLoading,
      tableData,
      filteredTableData,
      serverResponse,
      filter,
      search,

      showUserSelectModal,
      loadingAvailableUsers,
      loadingSavedUsers,
      savedUsersData,
      availableUsersData,

      searchAvailableUsers,
      searchSavedUsers,
      availableUsersAmount,
      savedUsersAmount,
      loadingMoreAvailableUsers,
      loadingMoreSavedUsers
    } = this.state;

    if (!!isLoading) {
      return (
        <Page>
          <AppContext.Consumer>
            {({ locale, activeUnitId, pillar }) => (
              this.setLocale(locale),
              this.setUnit(activeUnitId),
              this.setPillar(pillar),
              <span>{I18n.l('common.loadingTable')}</span>
            )}
          </AppContext.Consumer>
        </Page>
      );
    }

    return (
      <Page>
        <AppContext.Consumer>
          {({ locale }) => (
            this.setLocale(locale),
            <Wrapper>
              <ToolbarItem>
                <SearchComponent
                  onSubmit={this.searchData}
                  placeholder='form.placeholders.unitsSearch'
                  defaultValue={search}
                  buttonText='form.buttons.search'
                />
              </ToolbarItem>
              {tableData.length > 0 && (
                <div className="goepik-component-tablesize">
                  <Table
                    columns={tableColumns}
                    data={filter ? this.formatDataToTable(filteredTableData) : this.formatDataToTable(tableData)}
                    noPagination={true}
                    showConfirmationModal={false}
                  />
                </div>
              )}

              {tableData.length === 0 && <p>{locale && I18n.l('common.noResult')}</p>}
              {showUserSelectModal && (
                <SelectableUnitUserComponent
                  title={
                    I18n.l('form.titles.linkUserToProfile')
                  }
                  showModal={showUserSelectModal}
                  onToggleFormModal={() => this.toggleUserSelectModal()}
                  serverResponse={serverResponse}
                  onItemRemoved={this.onRemoveUser}
                  onItemSelected={this.onAddUser}

                  loadingAvailableData={loadingAvailableUsers}
                  loadingSavedData={loadingSavedUsers}

                  usersAvailableData={availableUsersData}
                  usersSavedData={savedUsersData}
                  usersAvailableTableColumns={usersAvailableTableColumns}
                  usersSavedTableColums={usersSavedTableColumns}

                  onSearchAvailableUsers={this.onSearchAvailableUsers}
                  onSearchSavedUsers={this.onSearchSavedUsers}
                  searchAvailableUsersValue={searchAvailableUsers}
                  searchSavedUsersValue={searchSavedUsers}

                  showMoreAvailableData={this.state.availableUsersCurOffset != undefined && this.state.availableUsersCurOffset != ''}
                  showMoreSavedData={this.state.savedUsersCurOffset != undefined && this.state.savedUsersCurOffset != ''}
                  onLoadMoreAvailableData={this.loadMoreAvailableUsers}
                  onLoadMoreSavedData={this.loadMoreSavedUsers}
                  loadingMoreAvailableData={loadingMoreAvailableUsers}
                  loadingMoreSavedData={loadingMoreSavedUsers}

                  ref={this.SelectableUserUnitRef}
                />

              )}

            </Wrapper>
          )}
        </AppContext.Consumer>
      </Page>
    );
  }
}



const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;

    .loading-more {
        margin: 15px 0;
        padding: 0;
        border: 0;
        text-align: left
    }

    .filter-group {
        margin-bottom: 50px;
    }
`;


const ToolbarItem = styled.div`
  width: 60%;
    flex: 1;
    margin-left: 50px;

    &:first-of-type {
        flex: 0;
        margin-left: 0;
    }
`;



export default Profile;
